import { Routes } from '@angular/router';
import { LoggedInAndUsersLoadedGuard } from '@customer-apps/user/services/logged-in-and-users-loaded.guard';
import { ModuleEnabledGuard } from '@customer-apps/enabled-modules/module-enabled.guard';

export const routes: Routes = [
  {
    path: 'app',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'app',
    redirectTo: '',
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () => import('app/home/home-routing.module').then((m) => m.HomeRoutingModule),
  },
  {
    path: 'account',
    loadChildren: () => import('app/account/account-routing.module').then((m) => m.AccountRoutingModule),
    canActivate: [LoggedInAndUsersLoadedGuard],
  },
  {
    path: 'dogs',
    loadChildren: () => import('@customer-apps/dog/dog-routing.module').then((m) => m.DogRoutingModule),
    canActivate: [LoggedInAndUsersLoadedGuard],
  },
  {
    path: 'members',
    loadChildren: () => import('@customer-apps/member/member-routing.module').then((m) => m.MemberRoutingModule),
    canActivate: [LoggedInAndUsersLoadedGuard],
  },
  {
    path: 'offerings',
    loadChildren: () => import('app/offering/offering-routing.module').then((m) => m.OfferingRoutingModule),
    canActivate: [LoggedInAndUsersLoadedGuard, ModuleEnabledGuard],
    data: { requiredModule: 'offering' },
  },
  {
    path: 'accounting',
    loadChildren: () => import('@customer-apps/accounting/accounting-routing.module').then((m) => m.AccountingRoutingModule),
    canActivate: [LoggedInAndUsersLoadedGuard],
  },
  {
    path: 'news',
    loadChildren: () => import('@customer-apps//news/news-routing.module').then((m) => m.NewsRoutingModule),
    canActivate: [LoggedInAndUsersLoadedGuard],
  },
  {
    path: 'chats',
    loadChildren: () => import('@customer-apps/chat/chat-routing.module').then((m) => m.ChatRoutingModule),
    canActivate: [LoggedInAndUsersLoadedGuard],
  },
  {
    path: 'teams',
    loadChildren: () => import('@customer-apps/team/team-routing.module').then((m) => m.TeamRoutingModule),
    canActivate: [LoggedInAndUsersLoadedGuard],
  },
  {
    path: 'groups',
    redirectTo: 'teams',
  },
  {
    path: 'files',
    loadChildren: () => import('@customer-apps//file/file-routing.module').then((m) => m.FileRoutingModule),
    canActivate: [LoggedInAndUsersLoadedGuard],
  },
  {
    path: 'preferences',
    loadChildren: () => import('app/preferences/preferences-routing.module').then((m) => m.PreferencesRoutingModule),
    canActivate: [LoggedInAndUsersLoadedGuard],
  },
  {
    path: 'organization',
    loadChildren: () => import('app/organization/organization-routing.module').then((m) => m.OrganizationRoutingModule),
  },
];
